import superagent from "superagent";
import  {store} from '/app/src/store/store';
import UserModel from '/app/src/model/User/model';
const request = superagent.agent()
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
                store.dispatch(UserModel.logout())
            }
        });
    });
export default request;



// WEBPACK FOOTER //
// src/lib/request.js